<template>
  <div class="relative w-full space-y-6 overflow-x-hidden p-4 lg:h-screen lg:space-y-12 lg:p-6">
    <div class="flex w-full flex-col gap-4 pt-6">
      <div class="flex flex-col-reverse gap-4 lg:flex-row lg:items-center">
        <h2 class="text-3xl font-bold drop-shadow-lg filter lg:text-5xl">Ranking da semana</h2>
        <i v-html="$icons.ranking_crown" class="h-8 w-8"></i>
      </div>
      <p class="text-sm lg:text-base">
        Entenda nossos critérios para definir o ranking da semana.
        <!-- href="https://ajuda.ontick.com.br/portal/pt-br/kb/articles/como-s%C3%A3o-selecionadas-a-estrat%C3%A9gias-do-destaques-da-semana-19-9-2024" -->
        <a
          href="https://ajuda.ontick.com.br/portal/pt-br/kb/articles/entendendo-destaques-da-semana-ontick"
          target="_blank"
          class="text-ontick-blue-600 z-50 cursor-pointer underline"
        >
          Clique aqui.
        </a>
      </p>
    </div>
    <ranking-table-component :data="data" @open-details="openDetails(item)" />
    <div class="mx-auto w-full space-y-4">
      <h4 class="font-bold">Disclaimer</h4>
      <p class="text-sm">
        Investimentos e estratégias de investimento apresentam riscos potenciais e retornos. Desempenhos passados não
        são indicativos de resultados futuros. Nós não garantimos qualquer resultado específico ou lucro. Você deve
        estar ciente dos riscos e estar disposto a aceitá-los para investir nos mercados. Qualquer decisão de
        investimento que você tome deve ser baseada em sua própria diligência e consideração de suas circunstâncias
        pessoais, incluindo, mas não se limitando a, sua tolerância ao risco, situação financeira e objetivos de
        investimento. Nós não nos responsabilizamos por quaisquer perdas que você possa sofrer como resultado do uso das
        informações, dados ou serviços da plataforma. Ao utilizar nosso site e nossos serviços, você concorda com este
        aviso de isenção de responsabilidade e assume total responsabilidade por suas decisões e ações.
      </p>
    </div>
  </div>
</template>

<script>
import rankingTableComponent from "../components/ranking-table.component.vue";

export default {
  components: { rankingTableComponent },

  data() {
    return {
      data: null,
    };
  },

  methods: {
    getRanking() {
      return this.$api
        .get(this.$endpoint.GET_RANKING)
        .then((res) => {
          // console.log(res);
          this.data = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },

  mounted() {
    this.getRanking();
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
